<template>
  <shared-header hide-breadcrumb>
    <template #filters>
      <rates-filters :loading="props.loading" />
    </template>

    <template #secondary-actions>
      <wb-button
        variant="primary"
        data-test-id="createRateButton"
        :label="mq.current === 'desktop' ? i18n.t('mywb.common.create-rate') : ''"
        icon="add"
        class="actions"
        :to="{ name: ROUTES.PAYMENTS_CREATE_RATE }"
      />
    </template>
  </shared-header>
</template>

<script setup lang="ts">
import RatesFilters from '@/components/filters/RatesFilters.vue'
import { useI18n } from '@/hooks/useI18n.hook'
import { useMq } from 'vue3-mq'
import SharedHeader from './SharedHeader.vue'
import ROUTES from '@/engine/router/routes'

const mq = useMq()
const i18n = useI18n()

interface Props {
  loading?: boolean
}
const props = defineProps<Props>()

</script>
